import {
    PUSH_ALERT,
    POP_ALERT,
} from '../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PUSH_ALERT:
            return [action.payload, ...state];
        case POP_ALERT:
            if (action.payload) // dismiss all
                return INITIAL_STATE;
            else // dismiss last
                return state.slice(0, -1);
        default:
            return state;
    }
};
